var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle62E = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M6.001 22.5a2.5 2.5 0 0 1 2.5-2.5h43a2.5 2.5 0 0 1 2.5 2.5v15a2.5 2.5 0 0 1-2.5 2.5h-43a2.5 2.5 0 0 1-2.5-2.5v-15ZM9 6h10l.752 8.274A2.5 2.5 0 0 1 17.262 17h-6.524a2.5 2.5 0 0 1-2.49-2.726L9 6Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m8 8 .223-.445A2.812 2.812 0 0 1 10.738 6h6.524c1.065 0 2.039.602 2.515 1.555L20 8"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M51 54H41l-.752-8.274A2.5 2.5 0 0 1 42.738 43h6.524a2.5 2.5 0 0 1 2.49 2.726L51 54Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m52 52-.223.445A2.813 2.813 0 0 1 49.262 54h-6.524a2.813 2.813 0 0 1-2.515-1.555L40 52"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M25 6h10l.752 8.274A2.5 2.5 0 0 1 33.262 17h-6.524a2.5 2.5 0 0 1-2.49-2.726L25 6Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m24 8 .223-.445A2.813 2.813 0 0 1 26.738 6h6.524c1.065 0 2.039.602 2.515 1.555L36 8"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M35 54H25l-.752-8.274A2.5 2.5 0 0 1 26.738 43h6.524a2.5 2.5 0 0 1 2.49 2.726L35 54Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m36 52-.223.445A2.813 2.813 0 0 1 33.262 54h-6.524a2.813 2.813 0 0 1-2.515-1.555L24 52"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M41 6h10l.752 8.274A2.5 2.5 0 0 1 49.262 17h-6.524a2.5 2.5 0 0 1-2.49-2.726L41 6Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m40 8 .223-.445A2.813 2.813 0 0 1 42.738 6h6.524c1.065 0 2.039.602 2.515 1.555L52 8"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M19 54H9l-.752-8.274A2.5 2.5 0 0 1 10.738 43h6.524a2.5 2.5 0 0 1 2.49 2.726L19 54Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m20 52-.223.445A2.813 2.813 0 0 1 17.262 54h-6.524a2.813 2.813 0 0 1-2.515-1.555L8 52"
})));
SvgRectangle62E.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle62E);
export default ForwardRef;